<template>
  <el-upload
    class="input imagen"
    :action="''"
    :class="{ 'inline-file-list': inlineFileList }"
    :auto-upload="false"
    v-model:file-list="uploadFiles"
    :on-change="onSelectFile"
    :accept="accept"
    :show-file-list="false"
    :list-type="showPreview ? 'picture': undefined"
    :disabled="limit === fileList.length"
    :multiple="multiple"
  >
  <el-button v-if="withBtn" size="small" :disabled="limit === fileList.length" :data-testid="buttonTestId">
    <span>{{ $t(labelTag) }}</span>
    <el-icon v-if="buttonIcon" class="uploadButtonIcon"><component :is="buttonIcon" /></el-icon>
  </el-button>
    <div v-else class="label" :data-testid="buttonTestId">{{ $t(labelTag) }}</div>
    
    <template #tip>
      <div class="el-upload__tip">
        <div class="fileContainer">
          <div v-for="(item, index) in fileList" :key="index" class="file">
            
            <el-icon :class="getItemIconClasses(item)"><component :is="getItemIcon(item)" /></el-icon>
            <span v-bind:class="item.error ? 'error' : ''">{{ item.name }}</span>
            
            <span
              class="delete"
              :class="{ disabled: item.uploading }"
              :aria-disabled="item.uploading"
              @click="onRemoveFile(index)"
            ><el-icon><Close /></el-icon></span>
            <img v-if="showPreview && showPreviewAux" :src="item.url" @click="onImageClick(item)" style="margin-top: 6px; display: block" width="100">
          </div>
        </div>
      </div>
    </template>
  </el-upload>
</template>

<script>
  import { showError } from '../Mensaje'
  import { mostrarMensajeInternacionalizado } from '../MensajeInternacionalizado/index'

  export default {
    name: 'FileUpload',
    props: {
      name: { type: String, default: 'uploadInput' },
      labelTag: { type: String, default: 'FILE_UPLOAD_cargar_imagen' },
      files: { type: Array, default: () => [] },
      storeAction: { type: String, default: '' },
      temporalDeleteAction: { type: String, default: '' },
      temporalId: { type: [String, Number], default: '' },
      deferFileDeletion: { type: Boolean, default: false },
      numeroArchivo: { type: Number, default: 0 },
      onFileListChange: { type: Function, default: null },
      onFileRemoved: { type: Function, default: null },
      cargandoArchivo: { type: Function, default: null },
      onFileNameChange: { type: Function, default: null },
      accept: { type: String, default: '*' },
      withBtn: { type: Boolean, default: true },
      showPreview: { type: Boolean, default: false },
      limit: { type: Number, default: undefined },
      multiple: { type: Boolean, default: false },
      foro: { type: Boolean, default: false },
      garantia: { type: Boolean, default: false },
      buttonTestId: { type: String, default: '' },
      buttonIcon: { type: String, default: '' },
      inlineFileList: { type: Boolean, default: false }
    },
    data() {
      return {
        fileList: this.inicializarLista(),
        uploadFiles: [],
        showPreviewAux: this.showPreview,
        fileExtension: undefined,
        arch: '',
        cargando: false,
        resolvedTemporalId: this.temporalId
      }
    },
    watch: {
      files() {
        this.fileList = this.inicializarLista()
        this.syncUploadFilesFromFileList()
      },
      temporalId(value) {
        this.resolvedTemporalId = value
      }
    },
    mounted() {
      this.syncUploadFilesFromFileList()
    },
    beforeUnmount() {
      this.fileList.forEach((item) => {
        if (item.createdObjectUrl && item.url) {
          URL.revokeObjectURL(item.url)
        }
      })
    },
    methods: {
      syncUploadFilesFromFileList() {
        this.uploadFiles = this.fileList.map((item) => ({
          name: item.name,
          url: item.url
        }))
      },
      inicializarLista() {
        return this.files.map((x) => { 
          return {
            name: x.name,
            url: x.url,
            uploading: false,
            error: false,
            createdObjectUrl: false,
            temporalId: x.temporalId,
            existing: x.existing === true
          } 
        })
      },
      onSelectFile(file) {
        // verifico si se superó el máximo de archivos permitidos
        if(this.limit !== undefined && this.limit <= this.fileList.length)
        {
          showError(this.$t('FILE_UPLOAD_limite_exedido'))
          return
        }        
        // verifico que la extension pertenezca a las permitidas
        let valido = false;
        if(this.accept !== "*")
        {
          // armo el array con las extensiones permitidas pasadas en la propiedad 'accept'
          let extensiones = this.accept.split(',.');
          // obtengo la extension del archivo que se quiere subir
          //this.file_extension = 
          var file_extension = file.name.split('.').pop().toLowerCase();
          this.fileExtension = file_extension;
          
          if (this.garantia) {
            // let num = numeroArchivo;
             this.arch = file.name.split('.')[0]
          }

          // verifico que la extension del archivo que se quiere subir pertenezca a las extensiones permitidas
          if(extensiones.filter(x => x == file_extension).length > 0)
            valido = true;
          // Si es una imagen (png o jpg), mostramos la preview
          
          if(file_extension === 'png' || file_extension === 'jpg'){
            this.showPreviewAux = true;
          }else{ this.showPreviewAux = false; }
          
        }
        else
          valido = true
          
        // si no es valida la extension muestro un mensaje de error
        if(!valido)
        {
          showError(this.$t('FILE_UPLOAD_extension_no_permitida'));
          return
        }

        if(this.foro == true && this.cargandoArchivo) {this.cargandoArchivo(true)}
        // creo un nuevo item de file
        const fileUrl = file.url || (file.raw ? URL.createObjectURL(file.raw) : '')
        let fileItem = {
          name: file.name,
          url: fileUrl,
          uploading: true,
          error: false,
          createdObjectUrl: !file.url && !!file.raw,
          temporalId: undefined,
          existing: false
        }
        this.fileList.push(fileItem)
        this.syncUploadFilesFromFileList()

         let payload = {}
        
        if (this.garantia) {
           
          payload = {
          file: file.raw,
          id: this.arch,
          numeroArchivo: this.numeroArchivo
        }
        } else {
          payload = {
          file: file.raw,
          id: this.resolvedTemporalId,
          numeroArchivo: this.numeroArchivo
        }
        }

        // subo el archivo
       

        this.$store.dispatch(this.storeAction, payload)
        .then(data => { 
            if(data.CodigoResultado === 0)
            {
              if (typeof data.Datos === 'string' && data.Datos.length > 0) {
                this.resolvedTemporalId = data.Datos
                fileItem.temporalId = data.Datos
              }
              fileItem.uploading = false
              this.listChanged()
            }
            else 
            {
              fileItem.uploading = false
              fileItem.error = true
              mostrarMensajeInternacionalizado(data.CodigoResultado, data.DescripcionResultado)
              this.listChanged()
            }
          },
          error => {
            fileItem.uploading = false
            fileItem.error = true
            const errorData = error && error.response ? error.response.data : undefined
            if (errorData) {
              mostrarMensajeInternacionalizado(errorData)
            }
            this.listChanged()
          }
        )
      },
      async onRemoveFile(index) {
        const item = this.fileList[index]

        if (!item || item.uploading) {
          return
        }

        const deferDeletion = this.deferFileDeletion && (item.existing || item.temporalId)

        if (this.temporalDeleteAction && item.temporalId && !deferDeletion) {
          try {
            const resultado = await this.$store.dispatch(this.temporalDeleteAction, {
              idTemporal: item.temporalId
            })
            if (!resultado || resultado.CodigoResultado !== 0) {
              mostrarMensajeInternacionalizado(resultado)
              return
            }
          } catch (error) {
            const errorData = error && error.response ? error.response.data : error
            mostrarMensajeInternacionalizado(errorData)
            return
          }
        }

        if (this.onFileRemoved) {
          this.onFileRemoved({ ...item })
        }

        if (item && item.createdObjectUrl && item.url) {
          URL.revokeObjectURL(item.url)
        }
        // quito el archivo de la lista
        this.fileList.splice(index, 1)
        this.syncUploadFilesFromFileList()
        this.listChanged()
      },
      listChanged() {
        let fileNames = this.fileList.map((x) => {
          return {
            name: x.name,
            url: x.url,
            temporalId: x.temporalId,
            existing: x.existing
          }
        })
        if (this.onFileListChange) {
          this.onFileListChange(this.name, fileNames)
        }
        if (this.cargandoArchivo) {
          this.cargandoArchivo(false)
        }
      },
      getItemIcon(fileItem) {
        if(fileItem.error)
          return 'CircleCloseFilled'
        
        else if(fileItem.uploading)
          return 'Loading'

        else
          return 'SuccessFilled' 
      },
      getItemIconClasses(fileItem) {
        return ['status-icon', fileItem.error ? 'icon-error' : fileItem.uploading ? 'is-loading' : 'icon-success']
      },
      onImageClick(fileItem) {
        window.open(fileItem.url, '_blank')
      },
      iniciandoCarga() {
        this.cargando = true
      },
      finalizandoCarga() {
        this.cargando = false
      }
    }
  }
</script>

<style scoped>

.fileContainer {
  margin-top: 10px;
  display: grid;
}

.file {
  margin: 2px 0;
}

.file .el-icon.status-icon {
  margin-right: 5px;
}

.file .el-icon.is-loading {
  color: var(--main-color);
}

.file .el-icon.icon-success {
  color: #068806;
}

.file .el-icon.icon-error {
  color: #F44336;
}

.file .delete {
  float: right;
  cursor: pointer;
}
.file .delete.disabled {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}
.file .delete .el-icon {
  margin: 2px;
}

.file img {
  cursor: pointer;
}

.label {
  font-size: 13px;
  color: var(--main-color);
}

.inline-file-list {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  vertical-align: middle;
}

.inline-file-list :deep(.el-upload) {
  display: inline-flex;
  align-items: center;
}

.inline-file-list .fileContainer {
  margin-top: 0;
  margin-left: 0;
  display: inline-flex;
  align-items: center;
  line-height: 1;
}

.inline-file-list .file {
  margin: 0;
  display: inline-flex;
  align-items: flex-end;
  gap: 6px;
  line-height: 1;
}

.inline-file-list .file > span {
  line-height: 1;
  display: inline-flex;
  align-items: center;
}

.inline-file-list .file .delete {
  float: none;
  display: inline-flex;
  align-items: center;
}

.inline-file-list :deep(.el-upload__tip) {
  display: inline-flex;
  align-items: center;
  margin-top: 0 !important;
  margin-left: 8px;
  line-height: 1;
  height: auto;
  padding: 0;
}

.inline-file-list .filePreview {
  position: absolute;
  top: 0;
  left: 100%;
  margin-left: 8px;
  z-index: 1;
}

.filePreviewImage {
  display: block;
}

.uploadButtonIcon {
  margin-left: 6px;
  vertical-align: middle;
}
</style>